import React from 'react'
export default function ScreenLoader() {
    return (
        <div className='load'>
            <div className="loader">
                <span className="item"></span>
                <span className="item"></span>
                <span className="item"></span>
                <span className="item"></span>
            </div>
        </div>
    )
}
